import React from "react";

function Home() {
  return <div style={{ height: "200vh" }}>Home</div>;
}

export default Home;
